<template>
  <b-container class="lower-list-container" fluid>
    <b-row class="lower-list-header" v-if="setPathHeader">
      <div class="back">
        <custom-button
          :label="'一つ上の階層'"
          :variant="'secondary'"
          :size="'sm'"
          :disabled="routePath.length < 2"
          :isFlex="true"
          :rounded="true"
          v-on:confirm="backDepartment"
        />
      </div>
      <b-col class="route-path-body" v-if="routePath.length > 0">
        <div class="route-path">
          <b-breadcrumb class="route-breadcrumb">
            <b-breadcrumb-item
              :class="{ head: index === 0 }"
              v-for="(dep, index) in routePath"
              :key="index"
              :active="index === routePath.length - 1"
              @click="clickRoutePath(dep)"
              >{{ dep.name }}</b-breadcrumb-item
            >
          </b-breadcrumb>
        </div>
      </b-col>
    </b-row>
    <b-row class="lower-list-option-header">
      <dropdown :activeIndex="activeIndex" :options="modeOptions" v-on:click="changeFilterMode" />
      <div class="ml-auto" v-if="filteredList.length && isSET">
        <custom-button
          :label="'設定をリセット'"
          :variant="'danger'"
          :size="'sm'"
          :isFlex="true"
          :rounded="true"
          v-on:confirm="resetAll"
        />
      </div>
      <div class="ml-auto" v-if="filteredList.length && !isSET">
        <custom-button
          :label="'全選択'"
          :size="'sm'"
          :isFlex="true"
          :rounded="true"
          v-on:confirm="selectedAll(true)"
        />
      </div>
      <div class="ml-1" v-if="filteredList.length && !isSET">
        <custom-button
          :label="'全解除'"
          :variant="'danger'"
          :size="'sm'"
          :isFlex="true"
          :rounded="true"
          v-on:confirm="selectedAll(false)"
        />
      </div>
    </b-row>
    <b-row :class="{ 'lower-list-body': true, 'no-path-header': !setPathHeader }">
      <div v-for="(item, index) of filteredList" :key="index" class="lower-list">
        <div class="lower-list-item">
          <div
            class="lower-list-item-label"
            @click="selectDepartment(item)"
            :class="item.isDeny ? 'deny' : 'allow'"
            :style="item.type === 'User' ? 'pointer-events: none;' : ''"
          >
            <b-icon-folder v-if="item.type === 'Department'" />
            <b-icon-person-circle v-else-if="item.type === 'User'" />
            {{ item.name }}
          </div>
          <check-box
            class="my-auto"
            :selected="!item.isDeny"
            v-on:change="clickedEditButton(item)"
          />
        </div>
      </div>
      <div v-if="searching">search in progress・・・</div>
      <div v-else-if="!filteredList.length">
        {{ emptyLabel }}
      </div>
    </b-row>
  </b-container>
</template>

<style scoped lang="scss">
@import "../../../node_modules/bootstrap/scss/functions";
@import "../../../node_modules/bootstrap/scss/variables";

$route-path-header-height: 30px;
$list-option-header-height: 40px;
$list-item-border: 1px solid #ced4da;
$option-label-color: rgb(150, 150, 150);
$selection-bgcolor: rgba($info, 0.2);

$normal: white;
$normal-hover: #f5f5f5;

$allow: #c5ebef;
$allow-hover: #9bdde2;

$deny: white;
$deny-hover: #e5e5e5;

.lower-list-container {
  height: inherit;

  .lower-list-header {
    display: flex;
    flex-direction: row;

    .back {
      padding: 0;
      margin-right: 8px;
    }

    .route-path-body {
      padding: 0;
      margin-left: auto;
      height: $route-path-header-height;
      font-size: 16px;
      display: flex;
      flex-direction: row;
      background-color: #f3f3f3;
      border: 1px solid #f3f3f3;
      border-radius: 10px;

      .route-path {
        display: flex;
        flex-direction: row;
        overflow-x: auto;
        margin-left: 8px;
        width: 100%;

        .route-breadcrumb {
          background-color: #f3f3f3;
          padding: 0;
          margin: 0;
          flex-direction: column;

          a {
            color: #8c8c8c !important;
          }

          li {
            color: #8c8c8c !important;
            &.active {
              color: black !important;
            }
            &:not(.head)::before {
              content: ">";
            }

            &.head ::before {
              content: "";
            }
          }
        }
      }
    }
  }

  .lower-list-option-header {
    display: flex;
    flex-wrap: nowrap;
    padding: 4px 0;
    height: $list-option-header-height;

    .mode-dropdown {
      font-size: 10px !important;

      &:hover {
        background-color: $selection-bgcolor;
        cursor: pointer;
      }
    }
  }

  .lower-list-body {
    overflow-y: auto;
    display: flex;

    max-height: calc(100% - #{$route-path-header-height} - #{$list-option-header-height});
    &.no-path-header {
      max-height: calc(100% - #{$list-option-header-height});
    }

    > .lower-list {
      width: 100%;
      position: relative;
      flex-direction: column;
      flex-grow: 1;
      flex-shrink: 1;

      .lower-list-item {
        padding: 4px 0;
        display: flex;
        flex-direction: row;

        .lower-list-item-label {
          background-color: $normal;
          width: calc(100% - 50px);
          border: $list-item-border;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 10px;
          cursor: pointer;

          &:hover {
            background-color: $normal-hover;
          }

          &.deny {
            background-color: $deny;

            .selected {
              background-color: $deny-hover;
            }

            &:hover {
              background-color: $deny-hover;
            }
            &:focus {
              background-color: $deny-hover;
            }
          }

          &.allow {
            background-color: $allow;

            .selected {
              background-color: $allow-hover;
            }

            &:hover {
              background-color: $allow-hover;
            }
            &:focus {
              background-color: $allow-hover;
            }
          }
        }

        .item-edit {
          margin: auto;
          align-self: center;
        }
      }
    }
  }
}
</style>

<script lang="ts">
import { computed, defineComponent, type PropType } from "vue";
import { User } from "@/model/user";
import { useUserStore } from "@/store";
import type { Department } from "./group-uesr-list/Departments/values/Department";
import { LowerListItem, IModeOption } from "./lower-list-type";
import Dropdown from "../common/CustomDropdown.vue";
import CheckBox from "../common/CheckBox.vue";
import CustomButton from "../button/CustomButon.vue";
import AclController from "./acl-controller";
import { SearchMode } from "./search-mode";

export default defineComponent({
  name: "lower-list",
  components: {
    Dropdown,
    CheckBox,
    CustomButton,
  },
  props: {
    lowerList: { type: Array as PropType<LowerListItem[]>, default: () => [], required: true },
    routePath: { type: Array as PropType<Department[]>, default: () => [], required: true },
    selectDepartmentIdStr: { type: String, default: "" },
    editMode: { type: Boolean, default: true },
    denyIdList: { type: Array as PropType<string[]>, default: () => [] },
    searching: { type: Boolean, default: false },
    activeIndex: { type: Number, default: 0 },
    modeOptions: {
      type: Array as PropType<IModeOption[]>,
      default: () => [IModeOption.DEFAULT, IModeOption.USER, IModeOption.SET],
    },
    aclController: { type: AclController as PropType<AclController>, default: new AclController() },
    searchMode: { type: String as PropType<SearchMode | undefined>, default: undefined },
  },
  setup(props, { emit }) {
    /** フィルターmode判定 */
    const isDEFAULT = computed((): boolean => {
      return props.modeOptions[props.activeIndex] === IModeOption.DEFAULT;
    });
    const isUSER = computed((): boolean => {
      return props.modeOptions[props.activeIndex] === IModeOption.USER;
    });
    const isSET = computed((): boolean => {
      return props.modeOptions[props.activeIndex] === IModeOption.SET;
    });

    const setPathHeader = computed((): boolean => {
      return !isSET.value && props.routePath.length > 0;
    });

    const emptyLabel = computed((): string => {
      switch (props.searchMode) {
        case SearchMode.ALL: {
          return "該当する部署・ユーザーが見つかりませんでした";
        }
        case SearchMode.DEPARTMENT: {
          return "該当する部署が見つかりませんでした";
        }
        case SearchMode.USER: {
          return "該当するユーザーが見つかりませんでした";
        }
        default: {
          if (isSET.value) {
            return "閲覧制限対象のユーザーは選択されていません";
          }
          return props.selectDepartmentIdStr
            ? "選択された部署に所属ユーザーが見つかりませんでした"
            : "部署が選択されていません";
        }
      }
    });

    const isExcept = (id: string): boolean => {
      return props.aclController.isExcept(id);
    };

    const isOwner = (id: string): boolean => {
      const me = useUserStore().me as User;
      return me.directId === id;
    };

    const changeFilterMode = (index: number, select?: string): void => {
      emit("changeFilterMode", { index: index, select: select });
    };

    const clickRoutePath = (department: Department): void => {
      if (props.selectDepartmentIdStr === department.departmentIdStr) return;
      emit("selectDepartment", department.departmentIdStr);
    };

    const selectDepartment = (item: LowerListItem): void => {
      if (item.type === "Department") {
        if (isSET.value) {
          changeFilterMode(0, item.id);
          return;
        }
        if (props.selectDepartmentIdStr === item.id) return;
        emit("selectDepartment", item.id);
      }
    };

    const backDepartment = (): void => {
      if (props.routePath.length > 1) {
        const department = props.routePath[props.routePath.length - 2];
        emit("selectDepartment", department.departmentIdStr);
      }
    };

    const clickedEditButton = (item: LowerListItem): void => {
      emit("clickedEditButton", item);
    };

    const isIncreased = (item: LowerListItem): boolean => {
      const itemId = item.id;
      return !props.denyIdList.includes(itemId);
    };

    const selectedAll = (checked: boolean): void => {
      emit("selectedAll", checked);
    };

    const resetAll = (): void => {
      emit("resetAll");
    };

    // NOTE: 旧 @Watch("lowerList", { immediate: true }) は Vue 2 の仕様により、親
    // （AclEditModal）が同一配列を splice/push で in-place 更新した場合でも発火していた。
    // Vue 2.7 の watch() は同一参照の配列では発火しないため（参照比較）、watch + ref では
    // 右ペインのリストが空のままになる退行が起きる。参照に依存しない computed に置き換える。
    const filteredList = computed((): LowerListItem[] => {
      return props.lowerList.filter((item) => {
        return !isExcept(item.id);
      });
    });

    return {
      filteredList,
      isDEFAULT,
      isUSER,
      isSET,
      setPathHeader,
      emptyLabel,
      isExcept,
      isOwner,
      changeFilterMode,
      clickRoutePath,
      selectDepartment,
      backDepartment,
      clickedEditButton,
      isIncreased,
      selectedAll,
      resetAll,
    };
  },
});
</script>
